import * as actions from '../actions'

var defaultState = null

export default function subscriptions(state = defaultState, action) {
    switch (action.type) {

        case actions.SUBSCRIPTION_GET:
            if (!action.error) {
                state = action.payload.data.objects
            }
            return state

        case actions.SUBSCRIPTION_CLEAN:
            return defaultState

        default:
            return state

    }
}



// WEBPACK FOOTER //
// ./state/reducers/subscriptions.js